export const BACKEND_ADDR = 'e767-91-199-224-67.ngrok-free.app';
// export const BACKEND_ADDR = '10.9.67.36:8000';

export const BACKEND_URL = 'https://' + BACKEND_ADDR;
export const API_URL = 'https://' + BACKEND_ADDR + '/api';

// export const BACKEND_URL = 'http://' + BACKEND_ADDR;
// export const API_URL = 'http://' + BACKEND_ADDR + '/api';
